import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { PrefilteredResourceLibraryItemsProvider } from '../../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import ComputingHome from './ComputingHome';
import { useApplicationsContent } from '../../graphql/pimcore/modules/siteContent/hooks/useApplicationsContent';
import DebouncedLoader from '../common/DebouncedLoader';

const ComputingPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();

    const { loading, error, contentTree } = useApplicationsContent();

    if (error) {
        return <div>Error loading application content.</div>;
    }

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered={true}>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <PrefilteredResourceLibraryItemsProvider
                    initialFilters={{
                        productApplicationKeys: ['Computing & Enterprise Systems'],
                    }}
                >
                    <Box
                        width="100%"
                        component="main"
                        sx={{
                            padding: 0,
                            flexGrow: 0,
                            p: 0,
                        }}
                    >
                        <ComputingHome contentTree={contentTree} />
                    </Box>
                </PrefilteredResourceLibraryItemsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};
export default ComputingPage;
